import React from 'react';
import ReactDOM from 'react-dom/client';

// Carattere Inter self-hosted (doc 07 §3): i font arrivano dal pacchetto
// npm @fontsource/inter e finiscono nel bundle, nessun servizio esterno.
// Solo i tre pesi ammessi dal documento: 400, 600, 700.
import '@fontsource/inter/400.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

// Tema unico QPSC (doc 07 §10.1): solo variabili --qpsc-*, importate una
// sola volta qui. Non modifica l'aspetto delle pagine esistenti.
import './theme.css';

// Le poche regole che valgono per l'APP INTERA: il fondo della finestra e
// due eredità che vivevano — per caso — dentro i fogli di pagina ritirati
// dal cantiere «grafica enrollment» (src/pages/Register.css e Login.css).
// Sta DOPO theme.css: usa i gettoni, quindi devono esistere già.
import './global.css';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ⚠️ QUI NON SI REGISTRA PIÙ IL SERVICE WORKER (Blocco 5, Fetta B, lavoro D).
// C'era una `navigator.serviceWorker.register('/firebase-messaging-sw.js')`
// NUDA e INCONDIZIONATA: partiva a ogni caricamento di pagina, prima ancora di
// sapere se ci fosse un utente collegato, e installava il worker delle
// notifiche anche a chi non ha fatto l'accesso e a chi le ha NEGATE.
// Lo STESSO service worker veniva poi registrato una seconda volta dall'hook
// `useFCMDeviceToken` — due punti vivi per un file solo.
// La sede della registrazione è ora UNA, ed è quella che sa chi è l'utente e
// se il permesso è stato concesso: `src/hooks/useFCMDeviceToken.js`.
// Non se ne rimettano di nuove qui.

// Il service worker "di app" di CRA (PWA/offline) resta disattivato: nessun
// modulo lo registra e nessun `service-worker.js` viene generato (niente
// workbox).
